import AddNoteButton from 'compositions/AddNoteButton';
import AssetOverview from 'compositions/AssetOverview';
import AssetSummaryWidget from 'compositions/AssetSummaryWidget';
import {
  CaseAssetsWidget,
  ServiceRequestAssetsWidget,
} from 'compositions/AssetsWidget';
import CancelServiceRequestButton from 'compositions/CancelServiceRequestButton';
import CaseClassicAssetDetailButton from 'compositions/CaseClassicAssetDetailButton';
import CaseOverview from 'compositions/CaseOverview';
import CaseStatusWidget from 'compositions/CaseStatusWidget';
import {
  CaseComplaintWidget,
  ServiceRequestComplaintWidget,
} from 'compositions/ComplaintWidget';
import {
  AssetFaultDiagnosticsWidget,
  CaseFaultDiagnosticsWidget,
} from 'compositions/DiagnosticsWidget';
import EstimateInvoiceDecidedWidget from 'compositions/EstimateInvoiceDecidedWidget';
import EstimateInvoicePendingWidget from 'compositions/EstimateInvoicePendingWidget';
import JumpToButton from 'compositions/JumpToButton';
import {
  CaseNotesWidget,
  ServiceRequestNotesWidget,
} from 'compositions/NotesWidget';
import {
  AssetLocationWidget,
  CaseLocationWidget,
  ServiceRequestLocationWidget,
} from 'compositions/LocationWidget';
import OpenEventsWidget from 'compositions/OpenEventsWidget';
import OptionsButton from 'compositions/OptionsButton';
import QRCodeWidget from 'compositions/QRCodeWidget';
import RequestServiceButton from 'compositions/RequestServiceButton';
import {
  CaseServiceProviderWidget,
  ServiceRequestServiceProviderWidget,
} from 'compositions/ServiceProviderWidget';
import ServiceRequestOverview from 'compositions/ServiceRequestOverview';
import {
  CaseServiceRequestInfoWidget,
  ServiceRequestServReqInfoWidget,
} from 'compositions/ServiceRequestWidget';

import AssetDetailData from 'containers/AssetDetailData';
import CaseDetailData from 'containers/CaseDetailData';
import ServiceRequestDetailData from 'containers/ServiceRequestDetailData';

import {
  ADD_NOTE_BUTTON,
  ASSET_DETAIL_DATA,
  ASSET_FAULT_DIAGNOSTIC_WIDGET,
  ASSET_LOCATION_WIDGET,
  ASSET_OVERVIEW,
  ASSET_SUMMARY_WIDGET,
  CANCEL_SERVICE_REQUEST_BUTTON,
  CASE_ASSETS_WIDGET,
  CASE_CLASSIC_ASSET_DETAIL_BUTTON,
  CASE_COMPLAINT_WIDGET,
  CASE_DETAIL_DATA,
  CASE_FAULT_DIAGNOSTIC_WIDGET,
  CASE_LOCATION_WIDGET,
  CASE_NOTES_WIDGET,
  CASE_OVERVIEW,
  CASE_SERVICE_PROVIDER_WIDGET,
  CASE_SERVICE_REQUEST_INFO_WIDGET,
  CASE_STATUS_WIDGET,
  ESTIMATE_INVOICE_DECIDED_WIDGET,
  ESTIMATE_INVOICE_PENDING_WIDGET,
  JUMP_TO_BUTTON,
  OPEN_EVENTS_WIDGET,
  OPTIONS_BUTTON,
  QR_CODE_WIDGET,
  REQUEST_SERVICE_BUTTON,
  SERVICE_REQUEST_ASSETS_WIDGET,
  SERVICE_REQUEST_COMPLAINT_WIDGET,
  SERVICE_REQUEST_DETAIL_DATA,
  SERVICE_REQUEST_LOCATION_WIDGET,
  SERVICE_REQUEST_NOTES_WIDGET,
  SERVICE_REQUEST_OVERVIEW,
  SERVICE_REQUEST_SERVICE_PROVIDER_WIDGET,
  SERVICE_REQUEST_SERV_REQ_INFO_WIDGET,
} from './constants';

export default {
  [ADD_NOTE_BUTTON]: AddNoteButton,
  [ASSET_DETAIL_DATA]: AssetDetailData,
  [ASSET_FAULT_DIAGNOSTIC_WIDGET]: AssetFaultDiagnosticsWidget,
  [ASSET_LOCATION_WIDGET]: AssetLocationWidget,
  [ASSET_OVERVIEW]: AssetOverview,
  [ASSET_SUMMARY_WIDGET]: AssetSummaryWidget,
  [CANCEL_SERVICE_REQUEST_BUTTON]: CancelServiceRequestButton,
  [CASE_ASSETS_WIDGET]: CaseAssetsWidget,
  [CASE_CLASSIC_ASSET_DETAIL_BUTTON]: CaseClassicAssetDetailButton,
  [CASE_COMPLAINT_WIDGET]: CaseComplaintWidget,
  [CASE_DETAIL_DATA]: CaseDetailData,
  [CASE_FAULT_DIAGNOSTIC_WIDGET]: CaseFaultDiagnosticsWidget,
  [CASE_LOCATION_WIDGET]: CaseLocationWidget,
  [CASE_NOTES_WIDGET]: CaseNotesWidget,
  [CASE_OVERVIEW]: CaseOverview,
  [CASE_SERVICE_PROVIDER_WIDGET]: CaseServiceProviderWidget,
  [CASE_SERVICE_REQUEST_INFO_WIDGET]: CaseServiceRequestInfoWidget,
  [CASE_STATUS_WIDGET]: CaseStatusWidget,
  [ESTIMATE_INVOICE_DECIDED_WIDGET]: EstimateInvoiceDecidedWidget,
  [ESTIMATE_INVOICE_PENDING_WIDGET]: EstimateInvoicePendingWidget,
  [JUMP_TO_BUTTON]: JumpToButton,
  [OPEN_EVENTS_WIDGET]: OpenEventsWidget,
  [OPTIONS_BUTTON]: OptionsButton,
  [QR_CODE_WIDGET]: QRCodeWidget,
  [REQUEST_SERVICE_BUTTON]: RequestServiceButton,
  [SERVICE_REQUEST_ASSETS_WIDGET]: ServiceRequestAssetsWidget,
  [SERVICE_REQUEST_COMPLAINT_WIDGET]: ServiceRequestComplaintWidget,
  [SERVICE_REQUEST_DETAIL_DATA]: ServiceRequestDetailData,
  [SERVICE_REQUEST_LOCATION_WIDGET]: ServiceRequestLocationWidget,
  [SERVICE_REQUEST_NOTES_WIDGET]: ServiceRequestNotesWidget,
  [SERVICE_REQUEST_OVERVIEW]: ServiceRequestOverview,
  [SERVICE_REQUEST_SERVICE_PROVIDER_WIDGET]: ServiceRequestServiceProviderWidget,
  [SERVICE_REQUEST_SERV_REQ_INFO_WIDGET]: ServiceRequestServReqInfoWidget,
};



// WEBPACK FOOTER //
// ./setup/ComponentRegistry/index.js